<template>
  <div class="attribute-preset">
    <div class="box">
      <a-tag v-show="list.length" color="red" style="font-size: 15px;margin-bottom: .8em">
        提示：填写完属性名和属性值后要点击【保存属性】按钮，确保成功保存。当铺货时的分类属性与预设属性匹配时会自动填充对应值
      </a-tag>
      <div class="content">
        <a-space class="item" v-for="(item, index) in list" :key="item">
          <span>属性名：</span>
          <a-input v-model:value="item.name" placeholder="请输入属性名（必填）" allowClear />
          <span>属性值：</span>
          <a-input v-model:value="item.value" :placeholder="'请输入' + item.name" allowClear />
          <a-tooltip placement="bottom">
            <template #title>删除该属性</template>
            <a-button type="primary" danger>
              <template #icon>
              <DeleteOutlined style="font-size: 18px" @click="deleteAttribute(item, index)" />
              </template>
            </a-button>
          </a-tooltip>
        </a-space>
      </div>
      <div v-show="!list?.length">
        当前还未预设属性，请点击右边的按钮，添加预设属性
      </div>
      <div class="add-btn">
        <a-tooltip placement="bottom">
          <template #title>添加属性</template>
          <a-button type="primary" @click="addAttribute">
            <template #icon>
            <PlusCircleOutlined style="font-size: 20px" />
            </template>
          </a-button>
        </a-tooltip>
      </div>
      <div v-show="list.length" class="save">
        <a-button type="primary" @click="saveAttribute">保存属性</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons-vue"
import { GetAttributePreset, UpdatePresetProperty } from './api'
export default {
  components: { PlusCircleOutlined, DeleteOutlined },
  data() {
    return {
      value: '',
      list: []
    }
  },
  methods: {
    async getAttributePresetList() {
      const { success, msg, list } = await GetAttributePreset()
      if (!success) this.$message.warning(msg)
      this.list = list?.length ? list : [
        { name: '生产企业统一社会信用代码', value: ''},
        { name: '生产企业名称', value: '' }, { name: '工业产品生产许可证', value: '' },
        { name: 'CCC证书编号', value: '' }, { name: '消毒品卫生许可证编号', value: '' },
        { name: '绿色食品认证编号', value: '' }, { name: '无公害农产品认证编号', value: '' },
        { name: '食品生产许可证编号', value: '' }, { name: '型号', value: '' }
      ]
    },
    addAttribute() {
      this.list.push({ name: '', value: '' })
    },
    async saveAttribute() {
      const data = {}
      if (this.list.length) {
        for(let attr of this.list) {
          if (attr.name) data[attr.name] = attr.value || ''
        }
      }
      const { msg , success } = await UpdatePresetProperty(data)
      if (!success) return this.$message.warning(msg)
      this.$message.success('保存预设属性成功')
      this.getAttributePresetList()
    },
    deleteAttribute(item, index) {
      this.list = this.list.filter((obj, i) => i !== index)
      const str = item.name ? `属性【${item.name}】` : '空属性'
      this.$message.success(`删除${str}成功`)
      this.saveAttribute()
    }
  },
  mounted() {
    this.getAttributePresetList()
  }
}
</script>
<style scoped lang='less'>
  @import './index';
</style>